import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    formId: String,
    checkboxSelector: String,
    uncheckedScopeValue: String
  }

  static targets = [
    "formHide",
    "confirmShow",
    "confirmHide",
    "scopeInput",
    "scopeOption",
    "submitConfirmShow",
    "submitConfirmHide"
  ]

  connect() {
    this.submitConfirmed = false
  }

  confirmDiscard(event) {
    event.preventDefault()
    this.hideFormModal()
    this.confirmShowTarget.click()
  }

  keepEditing(event) {
    event.preventDefault()
    this.confirmHideTarget.click()
    this.showFormModal()
  }

  discardChanges(event) {
    event.preventDefault()

    this.showFormModal()
    this.confirmHideTarget.click()
    this.formHideTarget.click()
  }

  confirmSubmit(event) {
    if (event.defaultPrevented) return

    if (this.submitConfirmed) {
      this.submitConfirmed = false
      return
    }

    if (this.shouldBypassSubmitConfirmation()) {
      this.applyScope(this.uncheckedScopeValueValue)
      return
    }

    event.preventDefault()
    this.hideFormModal()
    this.submitConfirmShowTarget.click()
  }

  submitWithConfirmation(event) {
    event.preventDefault()

    this.applyScope(this.selectedScopeValue())
    this.submitConfirmHideTarget.click()

    this.submitConfirmed = true
    this.formElement()?.requestSubmit()
  }

  discardSubmitChanges(event) {
    event.preventDefault()

    this.submitConfirmHideTarget.click()
    this.formHideTarget.click()
  }

  restoreFormModalOnFailure(event) {
    if (event.detail.success) return

    this.showFormModal()
  }

  hideFormModal() {
    this.formModalElement()?.classList.add("tw-invisible", "tw-pointer-events-none")
  }

  showFormModal() {
    this.formModalElement()?.classList.remove("tw-invisible", "tw-pointer-events-none")
  }

  formModalElement() {
    return this.hasFormIdValue ? document.getElementById(this.formIdValue) : null
  }

  formElement() {
    return this.element.querySelector("form")
  }

  selectedScopeValue() {
    const selectedOption = this.scopeOptionTargets.find((option) => option.checked)
    return selectedOption?.value
  }

  shouldBypassSubmitConfirmation() {
    if (!this.hasCheckboxSelectorValue) return false

    const checkbox = this.formElement()?.querySelector(this.checkboxSelectorValue)
    return Boolean(checkbox) && !checkbox.checked
  }

  applyScope(value) {
    if (!value || !this.hasScopeInputTarget) return

    this.scopeInputTarget.value = value
  }
}
